<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            optionList: options$ | async,
            disabled: disabled.$ | async,
            values: values.$ | async,
        } as data"
    >
        <ng-container *ngIf="ngControl.control; let control">
            <div
                [class]="'bazis-control ' + cssClassSizeControl"
                [ngClass]="{
                    'bazis-control--invalid': ngControl.control.invalid,
                    'bazis-control--disabled': data.disabled,
                    'bazis-control--dirty': ngControl.control.dirty,
                    'bazis-control--empty':
                        emptyValues.indexOf(ngControl.control.value) > -1 ||
                        (multiple && !ngControl.control.value?.length),
                }"
                clickOutside
                (clickOutside)="hideList()"
            >
                <bazis-label
                    [id]="attrId"
                    [isMajor]="hasTitleMajor"
                    [isEmptyLabel]="isEmptyLabel"
                    [title]="title || t(titleKey, titleParams)"
                    [required]="data.required"
                >
                    <bazis-interrogation
                        *ngIf="tooltipKey"
                        [slot]="tooltipSettings?.targetSide"
                        iconSize="compact"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipOffset]="[-8, 4]"
                        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                        [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                        [icon]="icons.interrogation"
                        [type]="interrogationType"
                    ></bazis-interrogation>
                </bazis-label>

                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--activated]="showList"
                    [class.bazis-control__field-group--disabled]="data.disabled"
                >
                    <bazis-control-field-start
                        [isClickable]="isLeftIconClickable"
                        [icon]="leftIcon"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        (actionClick)="onLeftIconClick($event)"
                    >
                    </bazis-control-field-start>

                    <div class="bazis-control__field">
                        <bazis-select-native
                            [attrId]="attrId"
                            [options]="data.optionList"
                        ></bazis-select-native>

                        <!-- Прекрасный кастомный селект -->
                        <div
                            class="bazis-select"
                            [class.bazis-select_secondary]="type === 'secondary'"
                            aria-hidden="true"
                        >
                            <div
                                *ngIf="selectedValues$ | async as selectedValues"
                                class="bazis-select__trigger"
                                (click)="toggleList()"
                            >
                                <ng-container
                                    *ngFor="let selected of selectedValues; let i = index"
                                >
                                    <bazis-item-with-icon-value
                                        [item]="selected"
                                    ></bazis-item-with-icon-value>
                                    {{ i < selectedValues.length - 1 ? ',' : '' }}
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <bazis-control-select-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [showList]="showList"
                        (toggled)="toggleList()"
                    >
                    </bazis-control-select-end>

                    <div
                        class="bazis-list bazis-list_control-dd bh-hide-xl-down"
                        [hidden]="!showList"
                    >
                        <bazis-multiple-selection-option
                            *ngFor="let option of data.optionList"
                            [option]="option"
                            [byCheckbox]="byCheckbox"
                            [multiple]="multiple"
                            [values]="data.values"
                            (toggled)="toggleValue(option.id)"
                        ></bazis-multiple-selection-option>
                    </div>

                    <div
                        class="bh-hide-xl-up"
                        *ngIf="showList"
                    >
                        <div class="bazis-modal mobile-bottom">
                            <div class="bazis-modal__content">
                                <div class="bazis-input-options_sort">
                                    <bazis-label [title]="t(titleMobileKey, titleMobileParams)">
                                    </bazis-label>
                                    <div
                                        *ngFor="let option of data.optionList; let i = index"
                                        [ngClass]="[multiple ? 'bazis-checkbox' : 'bazis-radio']"
                                    >
                                        <label (click)="toggleValue(option.id)">
                                            <input
                                                [type]="multiple ? 'checkbox' : 'radio'"
                                                [checked]="data.values.indexOf(option.id) > -1"
                                                (change)="preventDefault($event)"
                                                (click)="preventDefault($event)"
                                            />
                                            <span
                                                [ngClass]="[
                                                    multiple
                                                        ? 'bazis-checkbox__label'
                                                        : 'bazis-radio__label',
                                                    option.$snapshot.name ||
                                                    option.$snapshot.nameKey
                                                        ? ''
                                                        : 'bazis-label-hidden',
                                                ]"
                                            >
                                                <bazis-icon
                                                    *ngIf="option.$snapshot.icon"
                                                    [icon]="option.$snapshot.icon"
                                                    size="compact"
                                                ></bazis-icon>
                                                <ng-container *ngIf="option.$snapshot.name">
                                                    {{ option.$snapshot.name }}
                                                </ng-container>
                                                <ng-container *ngIf="option.$snapshot.nameKey">
                                                    {{
                                                        t(
                                                            option.$snapshot.nameKey,
                                                            option.$snapshot.nameParams
                                                        )
                                                    }}
                                                </ng-container>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <!-- <bazis-button
                                    color="action"
                                    class="bh-block"
                                    (click)="hideList()"
                                >
                                    {{ t('title.apply') }}
                                </bazis-button> -->
                            </div>
                        </div>

                        <div
                            class="bazis-backdrop bh-hide-xl-up"
                            (click)="hideList()"
                        ></div>
                    </div>
                </div>

                <div class="bazis-control__error">
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                </div>

                <div
                    *ngIf="noteKey"
                    class="bazis-control__note"
                >
                    {{ noteKey }}
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
